"use client";

import React from "react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Loader, ArrowRight, Mail, Phone, CircleCheck } from "lucide-react";
export default function TransformationJourneyCta() {
  return <section data-section-id="86690" id="聯繫專業團隊" className="dark bg-gradient-to-br from-purple-950 via-[#CBAACB] to-indigo-950 text-white py-24 relative overflow-hidden">
      {}
      <div className="absolute top-0 right-0 -translate-y-12 translate-x-1/3 w-[800px] h-[800px] bg-[#CBAACB]/20 rounded-full blur-[120px] pointer-events-none" />
      <div className="absolute bottom-0 left-0 translate-y-1/3 -translate-x-1/3 w-[600px] h-[600px] bg-[#CBAACB]/10 rounded-full blur-[100px] pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          {}
          <div className="max-w-xl">
            <h2 className="text-4xl md:text-5xl font-bold tracking-tight mb-6 text-white">需要專業建議？我們的個案經理隨時為您服務</h2>
            <p className="text-lg text-purple-100/80 mb-10 leading-relaxed">
              憬芯醫療 (Prospect Care) 致力為香港家庭提供全方位的居家醫護支援。無論是專業居家護理、物理治療或日常生活照顧，我們的資深團隊都能為您提供最溫暖的專業協助。
            </p>

            <div className="space-y-6">
              <div className="flex items-center gap-4">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/10 text-purple-200">
                  <Phone className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-sm text-purple-200/70 mb-1">諮詢熱線</p>
                  <p className="text-lg font-medium text-white">
                    5343 0380
                  </p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                <div className="flex items-center justify-center w-12 h-12 rounded-full bg-white/10 text-purple-200">
                  <Mail className="w-5 h-5" />
                </div>
                <div>
                  <p className="text-sm text-purple-200/70 mb-1">電子郵件</p>
                  <p className="text-lg font-medium text-white">
                    info@prospect-care.com
                  </p>
                </div>
              </div>
            </div>
          </div>

          {}
          <div className="bg-white/10 backdrop-blur-xl border border-white/20 p-8 sm:p-10 rounded-3xl shadow-2xl relative">
            <div className="absolute inset-0 bg-gradient-to-b from-white/10 to-transparent rounded-3xl pointer-events-none" />
            
            <div className="relative z-10">
              <h3 className="text-2xl font-semibold mb-6 text-white">
                預約居家護理諮詢
              </h3>
              
              <FormProvider formKey="contact_professional_team_home" formId="contact_professional_team_home" sectionName="transformation-journey-cta" defaultValues={{
              name: "",
              email: "",
              phone: "",
              company: "",
              needs: ""
            }} validationRules={{
              name: {
                required: true
              },
              email: {
                required: true,
                pattern: "email"
              },
              phone: {
                required: true,
                pattern: "phone"
              },
              company: {},
              needs: {}
            }} submitText="立即預約回電" successMessage="感謝您的查詢！我們的護理顧問將於 1 個工作天內與您聯繫，為您提供專業建議。">
                <CtaForm />
              </FormProvider>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function CtaForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="py-12 flex flex-col items-center text-center animate-in fade-in zoom-in duration-500">
        <div className="w-16 h-16 bg-emerald-500/20 text-emerald-400 rounded-full flex items-center justify-center mb-6">
          <CircleCheck className="w-8 h-8" />
        </div>
        <h4 className="text-xl font-semibold text-white mb-2">提交成功</h4>
        <p className="text-purple-100/70 mb-8 max-w-sm">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="w-full sm:w-auto border-white/20 text-white hover:bg-white/10">
          提交其他查詢
        </Button>
      </div>;
  }
  const whiteInputClass = "bg-white/95 text-zinc-900 dark:bg-white/95 dark:text-zinc-900 placeholder:text-zinc-400 dark:placeholder:text-zinc-400 border-transparent focus-visible:ring-purple-500 shadow-inner rounded-xl";
  return <Form onSubmit={handleSubmit} className="space-y-5">
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
        <FormField control={control} name="name" rules={{
        required: "請填寫聯絡人姓名"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/90">聯絡人姓名 <span className="text-purple-300">*</span></FormLabel>
              <FormControl>
                <Input placeholder="陳大文" className={whiteInputClass} {...field} />
              </FormControl>
              <FormMessage className="text-purple-300" />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "請填寫聯絡電話",
        pattern: {
          value: /^[0-9\-+() ]+$/,
          message: "請輸入有效的電話號碼"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-white/90">聯絡電話 <span className="text-purple-300">*</span></FormLabel>
              <FormControl>
                <Input type="tel" placeholder="5343 0380" className={whiteInputClass} {...field} />
              </FormControl>
              <FormMessage className="text-purple-300" />
            </FormItem>} />
      </div>

      <FormField control={control} name="email" rules={{
      required: "請填寫電子郵件",
      pattern: {
        value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "請輸入有效的電子郵件格式"
      }
    }} render={({
      field
    }) => <FormItem>
            <FormLabel className="text-white/90">電子郵件 <span className="text-purple-300">*</span></FormLabel>
            <FormControl>
              <Input type="email" placeholder="care@prospect-care.com" className={whiteInputClass} {...field} />
            </FormControl>
            <FormDescription className="text-xs text-white/50">我們會將護理資訊寄送至此信箱</FormDescription>
            <FormMessage className="text-purple-300" />
          </FormItem>} />

      <FormField control={control} name="company" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-white/90">服務類型 (如: 居家物理治療)</FormLabel>
            <FormControl>
              <Input placeholder="請填寫您感興趣的服務" className={whiteInputClass} {...field} />
            </FormControl>
            <FormMessage className="text-purple-300" />
          </FormItem>} />

      <FormField control={control} name="needs" render={({
      field
    }) => <FormItem>
            <FormLabel className="text-white/90">護理需求簡述</FormLabel>
            <FormControl>
              <Textarea placeholder="請簡要說明服務對象的身體狀況或照護目標" className={`resize-none min-h-[100px] ${whiteInputClass}`} {...field} />
            </FormControl>
            <FormDescription className="text-xs text-white/50">提供更多資訊，我們能更準確地為您配對專業人員</FormDescription>
            <FormMessage className="text-purple-300" />
          </FormItem>} />

      {submitError && <div className="p-3 bg-red-500/10 border border-red-500/20 rounded-md">
          <p className="text-sm text-red-400">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full h-12 text-base font-semibold mt-2 bg-white text-purple-900 hover:bg-purple-50 transition-colors rounded-xl" size="lg">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 w-5 h-5" />
            處理中...
          </> : <>
            立即預約專業回電
            <ArrowRight className="ml-2 w-5 h-5" />
          </>}
      </Button>
    </Form>;
}